import React from 'react'
import tw from "twin.macro";
import styled from "styled-components";


const HighlightedText = tw.span`bg-primary-500 text-white px-4  inline-block`;
const SubHeadings = ({heading1,heading2}) => {
  return (
    <p className="text-xl px-6 pt-2 font-bold keyHead text-gray-800">
    {heading1} &nbsp;
    <HighlightedText className="transform -skew-x-12">
     {heading2}
    </HighlightedText>
  </p>
  )
}

export default SubHeadings